import { cn } from '@bem-react/classname';

export const cnEditorWrapper = cn('EditorWrapper');

export namespace NEditorWrapper {

    export interface Props {

    }
}